import React, { useState } from "react";
import './MyProjects.scss';
// MyProjects
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
// Sliders
import { useLocation } from "react-router-dom";
import Faq from "react-faq-component";


export default function MyProjects({ ProjectList, setProjectList, }) {
    const url = new URL(window.location.href);

    const [scrollButton, setScrollButton] = useState(false);
    const location = useLocation()
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);

    useEffect(() => {
        (async () => {
            // console.log(ProjectList);
        })()


    }, [null]);

    return (
        <div className="MyProjects">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>My Projects | Track Your Service Bookings | HandyBy</title>

                {/* <!-- Short title --> */}
                <meta name="title" property="title" content="My Projects | HandyBy" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="My Projects | HandyBy" data-react-helmet="true" />

                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.handyby.com/og-image.jpg" data-react-helmet="true" />

                {/* <!-- Page URL --> */}
                <meta name="og:url" property="og:url" content="https://www.handyby.com/my-projects" data-react-helmet="true" />

                {/* <!-- Description --> */}
                <meta name="description" content="View And Manage All Your Home Service Projects In One Place. HandyBy Makes It Easy To Track Bookings, Chat With Pros, And Stay On Top Of Your Home Improvements." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="View And Manage All Your Home Service Projects In One Place. HandyBy Makes It Easy To Track Bookings, Chat With Pros, And Stay On Top Of Your Home Improvements." data-react-helmet="true" />

                <meta name="og:site_name" property="og:site_name" content="HandyBy" data-react-helmet="true" />

                <meta name="keywords" content="My Projects, HandyBy Dashboard, Track Home Services, Project Tracker, Home Repairs, Project Status, Home Service Management, Service Booking History, Manage Home Projects, Track Appointments, Verified Pros, HandyBy Services, View Scheduled Jobs" data-react-helmet="true" />
            </Helmet>

            <div className="CategoryNav">
                <div className="CategoryNavShape">
                    <span>
                        <h1>HandyBy /</h1>
                        <h1>My Projects</h1>
                    </span>
                </div>
            </div>
            <div className="MyProjectsHeader">
                <div className="MyProjectsHeaderLeft">
                    <h1>My Projects</h1>
                    <h2>Call or message them to discuss quotes.</h2>
                    <a href="/start-project"> <img src={require(`../../Images/construction.png`)} alt="Chimney Cleaning" /> Create Project</a>
                </div>
                <img src={require(`../../Images/document.png`)} alt="Chimney Cleaning" />
            </div>
            <div className="MyProjectsLlist">
                <div className="MyProjectsLlistHeader">
                    {ProjectList.length ?
                        <h1>Hi, {ProjectList[0].FirstName} {ProjectList[0].LastName} Here’s what’s next</h1>
                        :
                        <h1>Hi, Here’s what’s next</h1>
                    }
                    <h2>Pros quoting your project.</h2>
                    <div className="CategoryReviewsConfirmed">
                        <img src={require(`../../Images/info.png`)} alt="Chimney Cleaning" />
                        <h3>Companies on HandyBy can’t offer incentives or pay to hide any reviews.</h3>
                    </div>
                </div>
                <div className="MyProjectsLlistProjects">
                    {/* {console.log(ProjectList[a].TypeOfservices.length)} */}
                    {ProjectList.length ?
                        <div className="MyProjectsLlistProjectsMain">
                            {
                                ProjectList.map((A, index) => {
                                    return <div key={index} className="MyProjectsLlistProjectsBox">
                                        <h5>NEW PROJCET</h5>
                                        <h1>{A.Service} <span>/ {A.TypeOfPropery} </span></h1>
                                        <h3>Services reqested: {A.TypeOfservices.map((A2, index2) => <span key={index2}>{A2}{index2 == ProjectList[index].TypeOfservices.length - 1 ? "." : ","}</span>)}</h3>
                                        <h2><img src={require(`../../Images/plane.png`)} /> {A.DateForProject} Between {A.WindowTime}</h2>
                                        <h2><img src={require(`../../Images/information.png`)} /> {A.Address}{A.Apt ? " Apt " + A.Apt : ''}, {A.City} {A.ZipCode}</h2>
                                        {A.TellUsAboutYourProject.length ?
                                            <h4>
                                                <img src={require(`../../Images/info.png`)} alt="Chimney Cleaning" />
                                                {A.TellUsAboutYourProject}
                                            </h4>
                                            : null}
                                    </div>
                                })}
                            <a href="/start-project">Click to Create Another Project!</a>

                        </div>
                        :
                        <div className="MyProjectsLlistProjectsNoProject">
                            <h1>You don't have any projects yet</h1>
                            <a href="/start-project">Click to Create Project!</a>
                        </div>
                    }
                </div>
            </div>
            <NavigatorPath />
        </div >
    )
}

